const nav = {
  code: {
    FILTER_MENU: 0,
    SEARCH_FILTER: 1,
  },
};

// eslint-disable-next-line import/prefer-default-export
export { nav };
